import { ButtonBase } from "@reusejs/react";
import ChatSvg from "../../Icons/ChatSvg";
import LiveSupportSvg from "../../Icons/LiveSupportSvg";

export default function Queries() {
  return (
    <div className="relative bg-gray-50">
      <div className="hidden lg:flex relative sm:absolute w-full bottom-0 xl:inset-0 xl:h-full">
        <div className="h-full w-full xl:grid xl:grid-cols-2">
          <div className="h-full xl:relative xl:col-start-2 flex mx-auto items-end">
            <LiveSupportSvg />
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8 mt-7 lg:mt-0">
        <div className="relative pb-10 sm:pb-0 sm:py-10 lg:py-20">
          <h2 className="text-xl lg:text-4xl text-left font-semibold	lg:font-extrabold tracking-tight  leading-7">
            Do you have any queries?
          </h2>

          <div className="mt-1.5 lg:mt-6 sm:pr-24 text-left text-base	 lg:text-xl text-gray-500">
            Our experts are available at any time to assist you in the entire
            process.
          </div>
          <div className="flex flex-col lg:flex-row justify-center sm:justify-start mt-6">
            <div className="mr-0 lg:mr-2 w-full lg:w-[initial]">
              <ButtonBase
                variant="primary"
                type="submit"
                label="Talk to our Expert"
                onClick={() => {
                  console.log("button clicked");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  width: "w-full lg:w-[initial]",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "py-3.5 lg:px-2 py-2 sm:px-4 sm:py-3",
                }}
              />
            </div>
            <div className="mt-4 lg:mt-0 md:mb-6 lg:mb-0">
              <ButtonBase
                variant="primary"
                type="submit"
                label="Live support"
                buttonPrefix={
                  <div className="mr-2">
                    <ChatSvg />
                  </div>
                }
                onClick={() => {
                  console.log("button clicked");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-transparent",
                  textColor: "text-black hover:text-blue-700",
                  border: "border border-black border hover:border-blue-700",
                  padding: "py-3.5 lg:px-2 py-1 sm:px-4 sm:py-3",
                  width: "w-full lg:w-[initial]",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
